module.exports = __webpack_public_path__ + "@/assets/img/amerikan.f3767a06.jpeg";